<template>
  <div style="width: 100%">
    <!-- organograma da unidade -->
    <v-row id="grafico-organograma" class="justify-center ma-2">
      <organization-chart
        :dados="organizationChart.dados"
        :fonte="`Sistema Desenvolva, ${anoMapeamento}`"
        :nos="organizationChart.nos"
        :titulo="`Equipe da ${unidade.sigla}`"
        class="organization"
      />
    </v-row>

    <v-row>
      <v-toolbar flat>
        <v-toolbar-title>
          <h2 class="title primary--text text--darken-1 text-no-wrap mt-0">
            RESULTADOS
          </h2>
        </v-toolbar-title>
      </v-toolbar>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="[relatorio]"
          align-content-space-between
          class="elevation-0"
          disable-pagination
          hide-default-footer
        />
        <v-divider />
      </v-col>
    </v-row>

    <div v-if="relatorio.responsabilidadesConsolidadas.total > 0">
      <v-row>
        <v-col
          lg="6"
          md="5"
          sm="6"
        >
          <v-row class="justify-center">
            <pie-chart
              id="grafico-pizza-dificuldades"
              :dados="graficos.responsabilidade.pie2.series"
              :dados-complementares="graficos.responsabilidade.pie2.subSeries"
              :fonte="`Fonte: Sistema Desenvolva, ${anoMapeamento}`"
              class="chart-2"
              titulo="Comparativo de Dificuldades das Responsabilidades<br> Consolidadas"
            />
          </v-row>

          <!-- legenda do pie chart de dificuldade -->
          <v-row class="justify-center">
            <legenda-dificuldade />
          </v-row>
        </v-col>
        <v-col
          lg="6"
          md="5"
          sm="6"
        >
          <v-row class="justify-center">
            <pie-chart
              id="grafico-pizza-impactos"
              :dados="graficos.responsabilidade.pie.series"
              :dados-complementares="graficos.responsabilidade.pie.subSeries"
              :fonte="`Fonte: Sistema Desenvolva, ${anoMapeamento}`"
              class="chart-2"
              titulo="Comparativo de Impactos das Responsabilidades<br> Consolidadas"
            />
          </v-row>

          <!-- legenda do pie chart de impacto -->
          <v-row class="justify-center">
            <legenda-impacto />
          </v-row>
        </v-col>
      </v-row>
      <v-row class="justify-center">
        <v-col
          lg="6"
          md="5"
          sm="6"
        >
          <v-row class="justify-center">
            <pie-chart
              id="grafico-pizza-complexidades"
              :dados="graficos.responsabilidade.pie3.series"
              :dados-complementares="graficos.responsabilidade.pie3.subSeries"
              :fonte="`Fonte: Sistema Desenvolva, ${anoMapeamento}`"
              class="chart-2"
              titulo="Comparativo de Complexidades das Responsabilidades<br> Consolidadas"
            />
          </v-row>

          <!-- legenda do pie chart de complexidade -->
          <v-row class="justify-center">
            <legenda-complexidade />
          </v-row>
        </v-col>
      </v-row>

      <v-row class="mt-8">
        <v-toolbar flat>
          <v-toolbar-title>
            <h2 class="title primary--text text--darken-1 text-no-wrap mt-0">
              RESPONSABILIDADES CONSOLIDADAS
              {{ `(${relatorio.responsabilidadesConsolidadas.lista.length})` }}
            </h2>
          </v-toolbar-title>
        </v-toolbar>
      </v-row>
      <v-row>
        <v-col>
          <app-sort v-model="opcoes" />
        </v-col>
        <v-spacer />
        <v-col>
          <app-search v-model="opcoes" />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-data-table
            :headers="headersResponsabilidades"
            :items="relatorio.responsabilidadesConsolidadas.lista"
            :search="opcoes.pesquisa"
            :sort-by="opcoes.ordenarPor"
            :sort-desc="opcoes.decrescente"
            class="elevation-0"
            show-expand
            single-expand
          >
            <template v-slot:[`item.complexidade`]="{ item }">
              <span>{{ item.complexidadeConsolidado.nome.toUpperCase() }}</span>
            </template>
            <template
              v-slot:[`item.data-table-expand`]="{ item, expand, isExpanded }"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    height="100%"
                    text
                    width="100%"
                    @click="
                      expand(!isExpanded);
                      generateColumns(
                        colunas,
                        item.competenciasTecnicasConsolidado
                      );
                    "
                    v-on="on"
                  >
                    <v-badge right>
                      <template v-slot:badge>
                        <span>{{
                          item.competenciasTecnicasConsolidado.length
                        }}</span>
                      </template>
                      <v-icon
                        color="grey lighten-0"
                        large
                      >
                        build
                      </v-icon>
                    </v-badge>
                  </v-btn>
                </template>
                <span>Clique para exibir as competências técnicas</span>
              </v-tooltip>
            </template>
            <template v-slot:expanded-item="{ headers }">
              <td
                :colspan="headers.length"
                class="justify-center"
              >
                <v-row dense>
                  <v-spacer />
                  <v-col>
                    <v-row class="justify-center">
                      <h2
                        class="title primary--text text--darken-1 text-no-wrap"
                      >
                        COMPETÊNCIAS TÉCNICAS
                      </h2>
                    </v-row>
                  </v-col>
                  <v-spacer />
                </v-row>
                <v-row>
                  <v-spacer />
                  <v-col cols="10">
                    <v-simple-table
                      class="elevation-0 mb-4"
                      dense
                    >
                      <template v-slot:default>
                        <tbody>
                          <tr
                            v-for="column in colunas.lista"
                            :key="column.id"
                          >
                            <td
                              v-for="competencia in column"
                              :key="competencia.nomeAtual"
                              width="30%"
                            >
                              <div class="d-flex flex-row ma-1">
                                <span
                                  :class="
                                    competencia.tipo === 'GERAL'
                                      ? 'secondary--text'
                                      : 'grey-text text--darken-2'
                                  "
                                >{{ competencia.nomeAtual }}</span>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                  <v-spacer />
                </v-row>
              </td>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </div>
    <div v-else>
      <v-row>
        <v-col>
          <app-alert
            icon="info"
            message="Não há responsabilidades consolidadas na(s) unidade(s)."
            type="info"
          />
        </v-col>
      </v-row>
    </div>
    <!-- Relatório PDF e XLS -->
    <v-row
      class="justify-end mb-1"
    >
      <v-tooltip
        top
        max-width="400"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            color="success"
            class="mr-2"
            :disabled="relatorio.responsabilidadesConsolidadas.lista.length === 0"
            @click="generateWorksheet()"
            v-on="on"
          >
            <v-icon>get_app</v-icon>
            BAIXAR XLS
          </v-btn>
        </template>
        <span>Clique para baixar os dados em formato XLS.</span>
      </v-tooltip>
      <v-tooltip
        max-width="400"
        top
      >
        <template v-slot:activator="{ on }">
          <v-btn
            color="success"
            @click="getRelatorio()"
            v-on="on"
          >
            <v-icon>get_app</v-icon>
            BAIXAR PDF
          </v-btn>
        </template>
        <span>Clique para baixar o relatório dos dados em formato PDF.</span>
      </v-tooltip>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import PieChart from '@/components/chart/PieChart';
import OrganizationChart from '@/components/chart/OrganizationChart';
import AppAlert from '@/components/core/AppAlert';
import LegendaComplexidade from '@/components/monitoramento/desempenho/tecnico/LegendaComplexidade';
import LegendaDificuldade from '@/components/monitoramento/desempenho/tecnico/LegendaDificuldade';
import LegendaImpacto from '@/components/monitoramento/desempenho/tecnico/LegendaImpacto';
import AppSort from '@/components/core/AppSort';
import AppSearch from '@/components/core/AppSearch';
import { generatePDF, getCanvas } from '@/modules/relatorioPDF';
import { generateXLS } from '@/modules/relatorioPlanilha';

export default {
  name: 'MonitoramentoUnidadeResponsabilidade',

  components: {
    PieChart,
    OrganizationChart,
    AppAlert,
    LegendaComplexidade,
    LegendaDificuldade,
    LegendaImpacto,
    AppSort,
    AppSearch,
  },

  props: {
    mapeamento: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      headers: [
        {
          text: 'NOME UNIDADE',
          value: 'unidade.nome',
          sortable: false,
        },
        {
          text: 'SIGLA UNIDADE',
          value: 'unidade.sigla',
          align: 'center',
          sortable: false,
        },
        {
          text: 'RESPONSABILIDADES CADASTRADAS',
          value: 'responsabilidades.total',
          width: '10%',
          align: 'center',
          sortable: false,
        },
        {
          text: 'RESPONSABILIDADES VALIDADAS',
          value: 'responsabilidadesValidadas.total',
          width: '10%',
          align: 'center',
          sortable: false,
        },
        {
          text: 'RESPONSABILIDADES CONSOLIDADAS',
          value: 'responsabilidadesConsolidadas.total',
          width: '10%',
          align: 'center',
          sortable: false,
        },
        {
          text: 'QUANTIDADE DE SERVIDORES',
          value: 'participantes.length',
          width: '10%',
          align: 'center',
          sortable: false,
        },
      ],
      headersResponsabilidades: [
        { text: 'RESPONSABILIDADE', value: 'tituloConsolidado', sortable: false },
        {
          text: 'UNIDADE',
          value: 'unidade.sigla',
          width: '10%',
          align: 'center',
          sortable: false,
        },
        {
          text: 'DIFICULDADE',
          value: 'dificuldadeConsolidado.valor',
          width: '10%',
          align: 'center',
          sortable: false,
        },
        {
          text: 'IMPACTO',
          value: 'impactoConsolidado.valor',
          width: '10%',
          align: 'center',
          sortable: false,
        },
        {
          text: 'COMPLEXIDADE',
          value: 'complexidade',
          width: '10%',
          align: 'center',
          sortable: false,
        },
        {
          text: 'COMPETÊNCIAS',
          value: 'data-table-expand',
          width: '10%',
          align: 'center',
          sortable: false,
        },
      ],
      opcoes: {
        pesquisa: '',
        decrescente: false,
        ordenarPor: 'tituloConsolidado',
        selecionado: { id: 'tituloConsolidado', descricao: 'Responsabilidade' },
        lista: [
          { id: 'tituloConsolidado', descricao: 'Responsabilidade' },
          { id: 'unidade.sigla', descricao: 'Unidade' },
          { id: 'dificuldadeConsolidado.valor', descricao: 'Dificuldade' },
          { id: 'impactoConsolidado.valor', descricao: 'Impacto' },
          { id: 'complexidadeConsolidado.valor', descricao: 'Complexidade' },
          { id: 'competenciasTecnicasConsolidado', descricao: 'Competências' },
        ],
      },
      colunas: {
        id: '',
        lista: [],
      },
    };
  },

  computed: {
    ...mapState({
      relatorio: (state) => state.monitoramento.mapeamento.relatorio,
      graficos: (state) => state.monitoramento.mapeamento.graficosUnidade,
      graficosUnidades: (state) => state.monitoramento.mapeamento.graficosUnidades,
      unidade: (state) => state.monitoramento.mapeamento.unidade,
    }),
    anoMapeamento() {
      return this.mapeamento.ano ? this.mapeamento.ano : '';
    },
    organizationChart() {
      return {
        dados: this.graficosUnidades.organization.dados,
        nos: this.graficosUnidades.organization.nos.map((n) => {
          if (n.isGestor) {
            n.info = `<span style="color:#2D5269;font-weight:bold">${this.unidade.nome} (${
              this.unidade.sigla})</span><br/>`
              + `<span style="color:#348ECA;font-weight:bold">Responsabilidades Cadastradas: </span>${
                this.relatorio.responsabilidades.total}<br/>`
              + `<span style="color:#348ECA;font-weight:bold">Responsabilidades Validadas: </span>${
                this.relatorio.responsabilidadesValidadas.total}<br/>`
              + `<span style="color:#348ECA;font-weight:bold">Responsabilidades Consolidadas: </span>${
                this.relatorio.responsabilidadesConsolidadas.total}<br/>`
              + `<span style="color:#348ECA;font-weight:bold">Nº de Servidores: </span>${
                this.unidade.servidores.length + (this.unidade.gestor ? 1 : 0)
              }<br/>`;
          }
          return n;
        }),
      };
    },
  },

  methods: {
    getClassComplexidade(complexidade) {
      switch (complexidade.id) {
        case 'BAIXA':
          return 'secondary ml-1 white--text';
        case 'MEDIA':
          return 'warning ml-1 white--text';
        case 'ALTA':
          return 'error ml-1 white--text';
        default:
          return 'primary ml-1 white--text';
      }
    },
    generateColumns(columns, itens) {
      columns.id = '';
      columns.lista = [];
      const mid = Math.ceil(itens.length / 3);

      for (let col = 0; col < mid; col += 1) {
        columns.id = col;
        columns.lista.push(itens.slice(col * 3, col * 3 + 3));
      }
    },
    async getRelatorio() {
      const documento = {
        nome: 'relatorio-monitoramento-mapeamento-unidade-responsabilidade',
        cabecalho: {
          titulo: 'Relatório do Mapeamento Técnico por Unidade',
          itens: [
            'Tipo de monitoramento: Responsabilidade',
            `Unidade: ${this.unidade.sigla}`,
            `Mapeamento: ${this.mapeamento.nome}`,
          ],
        },
        blocos: [
          {
            titulo: 'GRÁFICOS',
            subtitulo: '',
            itens: [
              { tipo: 'imagem', valor: await getCanvas('#grafico-organograma') },
            ],
          },
          {
            titulo: 'RESULTADOS',
            subtitulo: '',
            itens: [{
              tipo: 'tabela',
              valor: {
                colunas: [
                  ...this.headers.map((h) => (
                    h.text
                  )),
                ],
                linhas: [this.relatorio].map((i) => [
                  i.unidade.nome,
                  i.unidade.sigla,
                  i.responsabilidades.total,
                  i.responsabilidadesValidadas.total,
                  i.responsabilidadesConsolidadas.total,
                  i.participantes.length,
                ]),
              },
            }],
          },
          !this.relatorio.responsabilidadesConsolidadas.total > 0 ? {
            titulo: '',
            subtitulo: '',
            itens: [
              { tipo: 'texto', valor: 'Info: Não há responsabilidades consolidadas na(s) unidade(s).' },
            ],
          } : {},
          this.relatorio.responsabilidadesConsolidadas.total > 0 ? {
            titulo: 'GRÁFICOS',
            subtitulo: '',
            itens: [
              {
                tipo: 'imagem',
                valor: await getCanvas('#grafico-pizza-dificuldades'),
                largura: 180,
                altura: 90,
              },
              {
                tipo: 'imagem',
                valor: await getCanvas('#grafico-pizza-impactos'),
                largura: 180,
                altura: 90,
              },
              {
                tipo: 'imagem',
                valor: await getCanvas('#grafico-pizza-complexidades'),
                largura: 180,
                altura: 90,
              },
            ],
          } : {},
          this.relatorio.responsabilidadesConsolidadas.total > 0 ? {
            titulo: `RESPONSABILIDADES CONSOLIDADAS (${this.relatorio.responsabilidadesConsolidadas.lista.length})`,
            subtitulo: '',
            itens: [{
              tipo: 'tabela',
              valor: {
                colunas: [
                  ...this.headersResponsabilidades.map((h) => (
                    h.text
                  )),
                ],
                linhas: this.relatorio.responsabilidadesConsolidadas.lista.map((i) => [
                  i.tituloConsolidado,
                  i.unidade.sigla,
                  i.dificuldadeConsolidado.valor,
                  i.impactoConsolidado.valor,
                  i.complexidadeConsolidado.nome.toUpperCase(),
                  i.competenciasTecnicasConsolidado.length,
                ]),
              },
            }],
          } : {},
        ],
      };
      generatePDF(documento);
    },
    generateWorksheet() {
      const documento = {
        titulo: 'responsabilidades-consolidadas',
        planilhas: [
          {
            titulo: 'Responsabilidades Consolidadas',
            colunas: [
              { header: 'RESPONSABILIDADE', key: 'responsabilidade', width: 50 },
              { header: 'UNIDADE', key: 'unidade', width: 15 },
              { header: 'DIFICULDADE', key: 'dificuldade', width: 15 },
              { header: 'IMPACTO', key: 'impacto', width: 15 },
              { header: 'COMPLEXIDADE', key: 'complexidade', width: 15 },
              { header: 'COMPETÊNCIAS', key: 'competencias', width: 40 },
            ],
            dados: this.relatorio.responsabilidadesConsolidadas.lista.map((r) => ({
              responsabilidade: r.tituloConsolidado,
              unidade: r.unidade.sigla,
              dificuldade: r.dificuldadeConsolidado.valor,
              impacto: r.impactoConsolidado.valor,
              complexidade: r.complexidadeConsolidado.nome.toUpperCase(),
              competencias: `${r.competenciasTecnicasConsolidado.map((c) => c.nomeAtual).join(', ')}`,
            })),
          },
        ],
      };

      generateXLS(documento);
    },
  },
};
</script>

<style scoped>
.chart {
  width: 100%;
  max-height: 400px;
  font-family: Roboto, sans-serif;
}

.chart-2 {
  max-height: 400px;
  font-family: Roboto, sans-serif;
}

.organization {
  width: 50%;
}
</style>
